var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#333333",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,29L22,23.3c-0.3-0.3-0.1-0.9,0.4-0.9l20.3-3.1c0.3-0.1,0.6,0.2,0.6,0.6l-3.1,20.3c-0.1,0.5-0.6,0.7-0.9,0.4l-5.7-5.7  c-6.1,6.3-7.6,15.5-4.5,23.2c1.2,2.9,3,5.6,5.5,7.9c4.6,4.1,10.6,5.9,16.4,5.4l-1.3,8.3c-6.8,0.1-13.6-2-19.1-6.4  c-3.3-2.6-5.8-5.7-7.7-9.1C16.7,53,18.3,38.6,27.7,29z M69.5,26.6c-5.5-4.4-12.4-6.5-19.1-6.4L49,28.6c5.8-0.5,11.8,1.3,16.4,5.4  c2.5,2.3,4.3,5,5.5,7.9c3.1,7.7,1.7,16.9-4.5,23.2l-5.7-5.7c-0.3-0.3-0.9-0.1-0.9,0.4l-3.1,20.3c-0.1,0.3,0.2,0.6,0.6,0.6l20.3-3.1  c0.5-0.1,0.7-0.6,0.4-0.9L72.3,71c9.4-9.6,11-24,4.8-35.2C75.3,32.3,72.7,29.2,69.5,26.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.98bdd4dd2357ec0f2c5ebf5766d153d6.svg";
export { ForwardRef as ReactComponent };